import type { ColorAnalysisOptions } from '../utils/color-analyzer';
import { ColorAnalyzer } from '../utils/color-analyzer';

type ValueType = string | File | HTMLImageElement | undefined;
function detectImageType(value: ValueType) {
  if (value instanceof HTMLImageElement) {
    return 'fromImage';
  }

  if (value instanceof File && value.type.startsWith('image/')) {
    return 'fromFile';
  }

  if (typeof value === 'string' && value.startsWith('data:image/')) {
    return 'fromBase64';
  }

  if (typeof value === 'string') {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    try {
      const url = new URL(value);
      const pathname = url.pathname.toLowerCase();
      const hasImageExt = imageExtensions.some((ext) => pathname.endsWith(ext));
      if (hasImageExt) return 'fromUrl';
    } catch (_) {
      console.error('Not a valid URL');
    }
  }

  return null;
}
export function useColorAnalyzer(value: ValueType, options?: ColorAnalysisOptions) {
  const [bgColor, setBgColor] = useState('');

  const handleBase64Analysis = useCallback(async () => {
    const type = detectImageType(value);
    if (!value || !type) {
      return;
    }
    const analyzer = new ColorAnalyzer();
    try {
      const bgColor = await analyzer[type](value as any, options);
      setBgColor(bgColor as string);
    } catch (error) {
      console.error(error);
    }
  }, [value, options]);

  useEffect(() => {
    handleBase64Analysis();
  }, [handleBase64Analysis]);

  return bgColor;
}
